enum CompanyRequestedForDeletionConstants {
  REMOVE_COMPANY_DELETION_REQUEST = '@CompanyRequestedForDeletionContainer/REMOVE_COMPANY_DELETION_REQUEST',
  REMOVE_COMPANY_DELETION_REQUEST_REQUEST = '@CompanyRequestedForDeletionContainer/REMOVE_COMPANY_DELETION_REQUEST_REQUEST',
  REMOVE_COMPANY_DELETION_REQUEST_REQUEST_SUCCESS = '@CompanyRequestedForDeletionContainer/REMOVE_COMPANY_DELETION_REQUEST_REQUEST_SUCCESS',
  REMOVE_COMPANY_DELETION_REQUEST_REQUEST_ERROR = '@CompanyRequestedForDeletionContainer/REMOVE_COMPANY_DELETION_REQUEST_REQUEST_ERROR',

  GET_COMPANY_DELETION_REQUEST_STATUS = '@CompanyRequestedForDeletionContainer/GET_COMPANY_DELETION_REQUEST_STATUS',
  GET_COMPANY_DELETION_REQUEST_STATUS_REQUEST = '@CompanyRequestedForDeletionContainer/GET_COMPANY_DELETION_REQUEST_STATUS_REQUEST',
  GET_COMPANY_DELETION_REQUEST_STATUS_REQUEST_SUCCESS = '@CompanyRequestedForDeletionContainer/GET_COMPANY_DELETION_REQUEST_STATUS_REQUEST_SUCCESS',
  GET_COMPANY_DELETION_REQUEST_STATUS_REQUEST_ERROR = '@CompanyRequestedForDeletionContainer/GET_COMPANY_DELETION_REQUEST_STATUS_REQUEST_ERROR',
}

export default CompanyRequestedForDeletionConstants;
